<!--
 * @Descripttion: 
 * @version: 
 * @Author: tangyuan
 * @Date: 2020-11-26 14:07:46
 * @LastEditors: tangyuan
 * @LastEditTime: 2020-11-26 14:39:04
-->
<template>
    <div class="banner banner-height">
        <img :src="banner" alt="">
    </div>
</template>

<script>
    export default {
        name:'Banner',
        props:['banner']
    }
</script>

<style lang="scss" scoped>
    .banner{
        img{
            height: 100%;
            width: 100%;
        }
    }
</style>